import { node, string } from "prop-types";

const propTypes = {
  title: string.isRequired,
  value: node,
  color: string,
};

const NarrativeBodyChartValue = (props) => {
  const { title, color, value } = props;
  return (
    <div className="narrative-body-chart-value">
      <div style={{ color: color || "currentColor" }}>
        <div className="narrative-body-chart-value__title">{title}</div>
        <div className="narrative-body-chart-value__value">{value || "-"}</div>
      </div>
    </div>
  );
};

NarrativeBodyChartValue.propTypes = propTypes;
export default NarrativeBodyChartValue;
